import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FormItemOptionModel } from "services/models/form-builder/form-item-option.model";
import { FormItemModel } from "services/models/form-builder/form-item.model";

@Component({
  selector: "app-form-input-multiselect",
  template: `
    <div class="flex flex-column gap-4">
      <ng-container
        *ngFor="let option of getOrderedOptions(item.options); let j = index"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            [id]="'option' + i + '-' + j"
            class="custom-control-input layout-name"
            [name]="'item-' + i"
            [value]="option.label || option"
            [checked]="(control.value || []).includes(option.label || option)"
            (change)="onCheckboxChange($event, option.label || option)"
            [disabled]="readonly"
          />
          <label
            class="custom-control-label question-item-label"
            [for]="'option' + i + '-' + j"
            [ngbTooltip]="option.legend"
          >
            {{ option.label || option }}
          </label>
        </div>
      </ng-container>
    </div>
  `,
})
export class FormInputMultiselectComponent {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() i!: number;
  @Input() readonly: boolean = false;

  getOrderedOptions(options?: FormItemOptionModel[]): FormItemOptionModel[] {
    if (!options) return [];
    return options.slice().sort((a, b) => (a.order || 0) - (b.order || 0));
  }

  onCheckboxChange(event: Event, value: string) {
    const currentValue = this.control.value || [];
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.control.setValue([...currentValue, value]);
    } else {
      this.control.setValue(currentValue.filter((v: string) => v !== value));
    }
  }
}
